module.exports = __webpack_public_path__ + "static/media/british-indian-ocean-territory.1ad24c62.png";